import { Controller } from '@hotwired/stimulus';

// Folders are browsed inside the documents <turbo-frame>, so the tab pane stays
// the same: Bootstrap ignores a click on an already active tab and the frame keeps
// the folder URL. Pointing the frame back at its root [src] brings the full list back.
export default class extends Controller {
  static values = { frame: String, src: String };

  reset() {
    const frame = document.getElementById(this.frameValue);
    if (!frame) return;

    const src = new URL(this.srcValue, window.location.href).href;
    const currentSrc = frame.getAttribute('src');
    if (currentSrc && new URL(currentSrc, window.location.href).href === src) return;

    frame.src = src;
  }
}
